import React from 'react';
import Button from 'jbc-front/components/Button';
import { useMutation, useQuery } from '../components/Graphql';
import { gql } from '@apollo/client';
import { Panel, Headding, Item, Lead, Description, Buttons } from '../components/PrimaryPanel';
import { ReportList, FINISHED_QUERY } from '../employee_pages/Finished';
import LoadingPage from '../components/LoadingPage';
import useReactRouter from 'use-react-router';
import { Hoc, reduxForm } from '../components';
import { parseBackUrl } from '../utils/url';
import { TextAreaField } from 'jbc-front/components/Form';
import { maxLength } from '../validators';
import { FORMER_JOBS_FRAGMENT } from './FormerJobs';
import styles from './Finish.scss';
import { Link } from 'react-router-dom';

const APPLY_REQUEST = gql`
  mutation applyRequest($comment: String) {
    applyRequest(input: { comment: $comment }) {
      request {
        id
        employee {
          id
          status
        }
      }
    }
  }
`;

const FORMER_JOBS = gql`
  query formerJobs {
    request {
      id
      profile {
        id
        ...FormerJobs
      }
    }
  }
  ${FORMER_JOBS_FRAGMENT}
`;

const Question = () => {
  const { data, loading } = useQuery(FINISHED_QUERY);
  const [answer, { loadingAnswer }] = useMutation(APPLY_REQUEST);
  const { data: formerJobs } = useQuery(FORMER_JOBS);

  const isWithholdingSlipInOrder = formerJobs?.request?.profile?.formerJobs?.some(
    formerJob => formerJob.withholdingSlipStatus === 'in_order'
  );

  const { history } = useReactRouter();
  if (loading) return <LoadingPage />;
  const {
    request: { profile }
  } = data;
  return (
    <Panel>
      <Headding>年末調整終了</Headding>
      <Item>
        <Lead>回答を提出します</Lead>
        {!profile || (!profile.needAdjThisYear && !profile.nextYearOnly) ? null : (
          <div>
            <Description>情報を確認・提出してください</Description>
            <ReportList />
            <Description>
              各申告書を確認し、誤りがない場合
              <b>画面下段の「情報を提出」ボタンをクリック</b>
              してください。
              <br />
              申告書に誤りがある場合、ナビゲーションバーから入力画面に戻り情報を修正してください。
            </Description>
          </div>
        )}

        {isWithholdingSlipInOrder && (
          <div className={styles.alert}>
            <p>
              <Link to="/employee_input?current=former_jobs">【注意】STEP 2-3 前職情報</Link>
              で源泉徴収票が【取り寄せ中】になっています。源泉徴収票の入手を待たずに年末調整を提出してよろしいですか？
            </p>
          </div>
        )}
        <Hoc
          makeHoc={() => reduxForm({ form: 'answer' })}
          onSubmit={async (values = {}) => {
            await answer({
              variables: { comment: values.comment || null }
            });
            history.push('/employee_input');
          }}
        >
          {({ submitting, handleSubmit }) => (
            <>
              <div>
                <div className="form_box_main">
                  <TextAreaField
                    name="comment"
                    label="管理者への連絡事項等"
                    placeholder="管理者へ伝えたい内容があれば記載してください"
                    validate={[maxLength(1000)]}
                  />
                </div>
              </div>
              <div>
                <Buttons>
                  <Button primary onClick={handleSubmit} disabled={submitting}>
                    情報を提出
                  </Button>
                </Buttons>
              </div>
            </>
          )}
        </Hoc>
      </Item>
    </Panel>
  );
};

export default Question;
